import { createApi } from '@reduxjs/toolkit/query/react'
import { authHeaderAPI } from 'redux/_helpers/auth-header'
import { baseQueryWithErrorHandler } from 'redux/_helpers/custom-base-query'
import { fetchBaseQuery } from '@reduxjs/toolkit/query'

export const TransportationsAPI = createApi({
  reducerPath: 'TransportationsAPI',
  baseQuery: baseQueryWithErrorHandler,
  tagTypes: ['TransportationsAPI'],
  endpoints: builder => ({
    addTransportation: builder.mutation<any, any>({
      query: body => ({
        url: '/api/Transportations/company',
        method: 'POST',
        body,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['TransportationsAPI'],
    }),
    addVehicles: builder.mutation<any, any>({
      query: ({ body, id }) => ({
        url: `/api/Transportations/company/${id}/vehicles`,
        method: 'POST',
        body,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['TransportationsAPI'],
    }),
    addTravels: builder.mutation<any, any>({
      query: ({ body, id }) => ({
        url: `/api/Transportations/company/${id}/travels`,
        method: 'POST',
        body,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['TransportationsAPI'],
    }),
    getTransportationById: builder.query({
      query: id => ({
        url: `/api/Transportations/${id}`,
        method: 'GET',
        headers: authHeaderAPI(),
      }),
      providesTags: ['TransportationsAPI'],
    }),
    getAllTransportations: builder.query({
      query: (params: any) => ({
        url: `/api/Transportations/companies`,
        method: 'GET',
        headers: authHeaderAPI(),
        params,
      }),
      providesTags: ['TransportationsAPI'],
    }),
    editVehicles: builder.mutation<any, any>({
      query: ({ body, id }) => ({
        url: `/api/Transportations/company/${id}/vehicles`,
        method: 'PUT',
        body,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['TransportationsAPI'],
    }),
    editTransportation: builder.mutation<any, any>({
      query: ({ body, id }) => ({
        url: `/api/Transportations/company/${id}`,
        method: 'PUT',
        body,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['TransportationsAPI'],
    }),
    editTravels: builder.mutation<any, any>({
      query: ({ body, id }) => ({
        url: `/api/Transportations/company/${id}/travels`,
        method: 'PUT',
        body,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['TransportationsAPI'],
    }),

    deleteTravels: builder.mutation({
      query: id => ({
        method: 'DELETE',
        url: `/api/Transportations/company/${id}`,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['TransportationsAPI'],
    }),
    getAllTravels: builder.query({
      query: (params: any) => ({
        url: `/api/Transportations/travels`,
        method: 'GET',
        headers: authHeaderAPI(),
        params,
      }),
      providesTags: ['TransportationsAPI'],
    }),
  }),
})

export const {
  useAddTransportationMutation,
  useAddVehiclesMutation,
  useGetAllTransportationsQuery,
  useGetTransportationByIdQuery,
  useAddTravelsMutation,
  useEditVehiclesMutation,
  useEditTransportationMutation,
  useEditTravelsMutation,
  useDeleteTravelsMutation,
  useGetAllTravelsQuery,
} = TransportationsAPI
